import styled from 'styled-components';

const NavWrapper = styled.div `
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
export default NavWrapper;